import { Injectable } from '@angular/core';
import { LoadingController, LoadingOptions } from '@ionic/angular';

type SpinnerType =
  | 'bubbles'
  | 'circles'
  | 'circular'
  | 'crescent'
  | 'dots'
  | 'lines'
  | 'lines-small'
  | 'lines-sharp'
  | 'lines-sharp-small';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  constructor(private loadingCtrl: LoadingController) {}

  /**
   * @description Muestra un loader con o sin texto
   * @param msg Mensaje a mostrar en el spinner, enviar el key del texto en vez de la traduccion
   * @param spinner Tipo de spiner a mostrar, por defecto es el de bubbles
   */
  public async simpleLoader(msg?: string, spinner: SpinnerType = 'bubbles'): Promise<HTMLIonLoadingElement> {
    const loadingOpts: LoadingOptions = {
      cssClass: 'anp-loader'
    };

    loadingOpts.spinner = spinner;
    if (msg) loadingOpts.message = msg;

    const loader = await this.loadingCtrl.create(loadingOpts);
    await loader.present();

    return loader;
  }
}
